export interface OATemplate {
  code               : string,
  height             : string,
  image_url          : string,
  is_ptte            : string,
  labels_per_sheet   : string,
  laser_enabled      : boolean,
  name               : string,
  packaging_image_url: string,
  image_code         : string,
  shape              : string,
  size               : string,
  template_id        : string,
  width              : string,
  cutting_pattern_pdf_url  : string, 
  project_size_description : string,
  project_snapshot_id      : string,
  project_stencil_id       : string,
  project_template_id      : string,
  is_custom_size           : string
};


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/models/oaTemplate.model.ts